// firebase.js

import firebase from "firebase/compat/app"; // Update import statement
import "firebase/compat/messaging"; // Import Firebase Messaging module

// Must match fnt/src/services/firebase.js and adm/public/firebase-messaging-sw.js
const firebaseConfig = {
  apiKey: "AIzaSyDPCgvnSk8WyO6KrDYfLyHCwwZqPd9P988",
  authDomain: "Empireludo-ab00c.firebaseapp.com",
  projectId: "Empireludo-ab00c",
  storageBucket: "Empireludo-ab00c.firebasestorage.app",
  messagingSenderId: "758308593105",
  appId: "1:758308593105:web:ed1690eea0107a7d3c14f0",
  measurementId: "G-DERE6CRLRM",
};

const app = firebase.initializeApp(firebaseConfig);

export default app; // Export the initialized Firebase app
